export function clampStep(step: number, total: number): number {
    return Math.min(Math.max(step, 0), Math.max(total - 1, 0));
}

export function nextStep(step: number, total: number): number {
    return clampStep(step + 1, total);
}

export function previousStep(step: number, total: number): number {
    return clampStep(step - 1, total);
}

export function isFinalStep(step: number, total: number): boolean {
    return step >= total - 1;
}
